import { AccountLayout } from '../../layouts';
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../src/layouts/index";
import { UserAccountSettingForm } from '../../components/UserAccountSetting';

export const UserAccountSettingPage = () => {
  return (
		<AuthenticatedLayout
			pageTitle="User Account Setting"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[
				{ text: "Account Setting", navigateTo: "/user-account-setting" },
			]}
			mainContents={<UserAccountSettingForm />}
		/>
	);
};
